import { useEffect } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import UserDetails from "../UserDetails/UserDetails";
import { uiAction } from "../../store/ui-gemini";
import { getMe } from "../../store/auth-action";
import SlideSection from "../Slide/index";

const CommunityLayout = () => {
  const isUserDetails = useSelector((state) => state.ui.isUserDetailsShow);
  const isLogin = useSelector((state) => state.auth.isLogin);
  const isDark = useSelector((state) => state.ui.isDark);
  const dispatch = useDispatch();
  const isWelcomeModalOpen = useSelector((s) => s.ui.isWelcomeModalOpen);

  useEffect(() => {
    const theme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", theme);
  }, [isDark]);

  // Load user data if not already loaded
  useEffect(() => {
    const isLoginLocal = localStorage.getItem("isLogin");
    if (isLoginLocal && !isLogin) {
      dispatch(getMe());
    }
  }, [dispatch, isLogin]);

  return (
    <div className="App">
      <div className="w-full h-full flex flex-col items-stretch text-left overflow-auto">
        <Header />
        <div className="p-4 overflow-scroll max-h-[calc(100vh_-_60px)]">
          <Outlet />
        </div>
      </div>
      {!isWelcomeModalOpen && <SlideSection />}
      {isUserDetails && isLogin && <UserDetails />}
      {isUserDetails && isLogin && (
        <div
          onClick={() => dispatch(uiAction.toggleUserDetailsShow())}
          className="bg-focus-dark"
        ></div>
      )}
    </div>
  );
};

export default CommunityLayout;


